import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'
import {mountMorePage} from '../../../../../shared/scripts/more/mountMorePage.ts'
import {UIPopupRulebook} from '../../../../../shared/scripts/ui_popup/UIPopupRulebook.ts'
import {RulebookPage} from '../../../../../../shared/enums/RulebookEnums.ts'

export class UIDMoreSceneController {
    private readonly sidebarController: UISidebarController
    private readonly moreSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.moreSceneContainerDiv = document.getElementById('scene_discord_more_container') as HTMLDivElement

        mountMorePage('discord-more-page-container', () => new UIPopupRulebook(RulebookPage.Classic4P).show(), {
            faqExternalUrl: 'https://colonist.io/faq',
        })
    }

    hide() {
        this.moreSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.moreSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.activateMore()
    }
}
